import PropTypes from 'prop-types'
import React from 'react'

import { UNIT_TYPES } from 'constants'
import { BATTLE_TITLES } from 'helpers/i18n'
import { BATTLE_TITLE_TOOLTIPS_ID } from '../../constants.jsx'

import styles from './BattleTitle.scss'

const BattleTitle = (props) => {
    return (
        <h2 className={styles.base}>
            {BATTLE_TITLES[props.type]}
            <span
                className={styles.info}
                data-tip
                data-for={BATTLE_TITLE_TOOLTIPS_ID[props.type]}
            />
        </h2>
    )
}

BattleTitle.propTypes = {
    type: PropTypes.oneOf(Object.values(UNIT_TYPES)).isRequired,
}

export default BattleTitle



// WEBPACK FOOTER //
// ./components/BattleWizard/components/BattleTitle/BattleTitle.jsx